import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_VEHICLE_MANAGER } from '../redux/constants/rolesConstants';
import BrandsHeader from '../components/brands/BrandsHeader';
import BrandsList from '../components/brands/BrandsList';
import BrandsPagination from '../components/brands/BrandsPagination';
import Container from '../components/shared/container/Container';
import CommonLoader from '../components/shared/loaders/CommonLoader';
import PageTitle from '../components/shared/page/PageTitle';
import PageTitleContainer from '../components/shared/page/PageTitleContainer';

const Brands = () => {
  const readOnly = !useSelector((state) => state.auth?.userData?.roles.includes(ROLE_VEHICLE_MANAGER));
  return (
    <Suspense fallback={<CommonLoader />}>
      <section>
        <PageTitleContainer>
          <PageTitle title={'Марки автомобілів'} />
        </PageTitleContainer>
        <Container>
          <BrandsHeader readOnly={readOnly} />
          <BrandsList readOnly={readOnly} />
          <BrandsPagination />
        </Container>
      </section>
    </Suspense>
  );
};

export default Brands;
